import { Box, Typography } from '@mui/material';

export const StepperMobile = ({ steps, activeStep = 0 }) => {
  return (
    <Box width='100%'>
      {/* Texto superior */}
      <Typography
        variant='body1'
        sx={{
          mb: 1,
          fontWeight: 500,
        }}
        textAlign={'center'}
      >
        Paso {activeStep + 1} de {steps.length}: {steps[activeStep]}
      </Typography>

      {/* Barra de progreso */}
      <Box display='flex' gap={1}>
        {steps.map((_, index) => (
          <Box
            key={index}
            flex={1}
            height={6}
            sx={{
              borderRadius: 3,
              backgroundColor: index <= activeStep ? '#2e7d32' : '#e0e0e0',
              transition: 'all 0.3s ease',
            }}
          />
        ))}
      </Box>
    </Box>
  );
};
